import React, { useMemo, } from "react";
import
{
  FormAutocomplete,
  formClasses,
  labelClasses,
  LabeledAutocomplete,
} from "../styles/AutocompleteStyles";
import
{
  handleMUISelectEvent,
} from "../utils/UtilFunctions";
import { Keys } from "../utils/Enum.keys";
import { TextField } from "@mui/material";
import { EMPTY_STRING } from "../utils/constants";
import { empType } from "../utils/Enum.types";

interface Props
{
  value: string;
  onChange: ( newValue: string ) => void;
  label?: string;
  disabled?: boolean;
  autofocus?: boolean;
  filterOptions?: empType[];
}
const EmpTypeSelect = ( {
  value,
  onChange,
  label,
  disabled,
  autofocus,
  filterOptions
}: Props ) =>
{
  const empOptions = Object.values( empType ).filter(
    ( emp ) => emp !== empType.NONE
  );

  const fillteredOptions = useMemo( () =>
  {
    if ( filterOptions )
    {
      return empOptions.filter( ( emp ) => !filterOptions.includes( emp ) );
    } else
    {
      return empOptions;
    }
  }, [] )
  const commonAutocompleteProps = {
    className: label ? labelClasses.inputRoot : formClasses.inputRoot,
    options: fillteredOptions,
    openOnFocus: true,
    disabled: disabled,
    onChange: ( e: React.SyntheticEvent<Element, Event>, value: unknown ) =>
      onChange( value as string ),
  };

  const commonTextFieldProps = {
    label: label || "",
    fullWidth: true,
    InputLabelProps: { shrink: label ? true : false },
    className: label
      ? labelClasses.formControlRoot
      : formClasses.formControlRoot,
  };

  const Autocomplete = label ? LabeledAutocomplete : FormAutocomplete;

  return (
    <Autocomplete
      {...commonAutocompleteProps}
      value={value}
      // Conditional value
      isOptionEqualToValue={( option ) =>
        ( option as string ) === value || value === EMPTY_STRING
      }
      onKeyDown={( e ) =>
      {
        if ( e.key === Keys.ENTER )
        {
          handleMUISelectEvent( e );
        }
      }}
      // getOptionLabel={(option) =>
      //   toStandardCase(option as string).replaceAll("_", " ")
      // }
      // autoComplete={false}
      renderInput={( params ) => (
        <TextField
          {...params}
          {...commonTextFieldProps}
          autoFocus={autofocus}
          autoComplete="one-time-code"
        />
      )}
    />
  );
};

export default EmpTypeSelect;
